'use strict';

module.exports = function pop() {
  return this.items.pop();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/pop.js
// module id = 277
// module chunks = 0